import React from 'react';
import styles from './sidebar.module.scss';
import { Icons } from '@miro-site/ui-design-system';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SidebarHeader = function SidebarHeader(_ref) {
  var children = _ref.children,
      _ref$withBackButton = _ref.withBackButton,
      withBackButton = _ref$withBackButton === void 0 ? false : _ref$withBackButton,
      onBackButtonClick = _ref.onBackButtonClick,
      onCloseClick = _ref.onCloseClick,
      _ref$showShadow = _ref.showShadow,
      showShadow = _ref$showShadow === void 0 ? false : _ref$showShadow;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.transitionShadow, 'border-bottom px-300 py-300 transition-all', {
      'shadow-50': showShadow
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "align-items-center d-flex justify-content-start gap-150",
      children: [withBackButton && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("span", {
          className: "btn btn-link",
          onClick: onBackButtonClick,
          children: /*#__PURE__*/_jsx(Icons.ChevronLeft, {
            className: "text-black",
            size: 300
          })
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "me-150",
        children: /*#__PURE__*/_jsx("strong", {
          children: children
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "ms-auto",
        children: /*#__PURE__*/_jsx("span", {
          className: "btn btn-link",
          onClick: onCloseClick,
          children: /*#__PURE__*/_jsx(Icons.Cross, {
            className: "text-black",
            size: 300
          })
        })
      })]
    })
  });
};